<template>
  <div>
    <CCard>
      <DatePicker
        v-model="value1"
        type="date"
        range
        placeholder="Select date range"
        style="float: left"
      ></DatePicker>
      <CCardBody>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
          responsive
        >
          <template #icon="{ item }">
            <td>
              <img :Src="item.icon" class="icon" />
            </td>
          </template>
          <template #matchStatus="{ item }">
            <td>
              <span v-if="item.matchStatus == 'Live'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-success ml-1"
                >
                  Live
                </a></span
              >
              <span v-if="item.matchStatus == 'Completed'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                  Completed
                </a></span
              >
              <span v-if="item.matchStatus == 'Cancelled'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-danger ml-1"
                >
                  Cancelled
                </a></span
              >
              <span v-if="item.matchStatus == 'Upcoming'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-info ml-1"
                >
                  Upcoming
                </a></span
              >
            </td>
          </template>
          <template #winners="{ item }">
            <td class="">
              <CButton
                v-if="item.matchStatus == 'Upcoming'"
                class="px-3"
                color="success"
                @click="goToEditEsportsTournament(item)"
                >Edit</CButton
              >
              <CButton
                v-if="item.matchStatus == 'Live'"
                class="px-3 my-2"
                color="success"
                @click="goToEditEsportsPrizeDistribution(item)"
                >Prize Distribution</CButton
              >
              <JsonCSV
                v-if="
                  item.matchStatus == 'Completed' && item.winners.length != 0
                "
                color="success"
                class="btn btn-default mb-2 clr"
                :data="item.winners"
                name="Tournaments_winners.csv"
                style="background: aquamarine"
              >
                Download
              </JsonCSV>

              <CButton
                v-if="item.matchStatus == 'Live'"
                class="px-3 my-2"
                color="danger"
                @click="matchCancel(item)"
                >Cancel</CButton
              >
            </td>
          </template>
          <template #View="{ item }">
            <td class="d-flex">
              <CButton color="primary" @click="filterdata(item.id)"
                >View users</CButton
              >
              <CButton
                v-if="
                  item.matchStatus == 'Upcoming' || item.matchStatus == 'Live'
                "
                color="success"
                class="ml-2"
                @click="editTournament(item)"
                >Edit</CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
  <script>
import firebase from "firebase";
const db = firebase.firestore();
import moment from "moment";
import Swal from "sweetalert2";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
export default {
  name: "EsportsTournamentList1Vue",
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      value1: [],
      tableData: [],
      fields: [
        {
          label: "Icon",
          key: "icon",
          sortable: true,
        },
        {
          label: "Name",
          key: "name",
          sortable: true,
        },
        {
          label: "created",
          key: "created",
          sortable: true,
        },
        {
          label: "Match Status",
          key: "matchStatus",
          sortable: true,
        },
        {
          label: "Esports ID",
          key: "esportsID",
          sortable: true,
        },
        // {
        //   label: "Tournament ID",
        //   key: "tournamentId",
        //   sortable: true,
        // },
        {
          label: "tournament Name",
          key: "tournamentName",
          sortable: true,
        },

        {
          label: "Winners",
          key: "winners",
          sortable: true,
        },
        {
          label: "View",
          key: "View",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      try {
        console.log("yes heree");
        var res = new Date(this.value1[1]);
        res.setDate(res.getDate() + 1);
        let v1 = firebase.firestore.Timestamp.fromDate(
          new Date(this.value1[0])
        );
        let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
        db.collection("esportsTournament")
          .where("isContestEnabled", "==", true)
          .where("created", ">", v1)
          .where("created", "<", v2)
          .get()
          .then((snapshot) => {
            this.tableData = [];
            snapshot.forEach((doc) => {
              this.tableData.push({
                id: doc.id,
                name: doc.data().gameName,
                icon: doc.data().gameImage,
                matchStatus: doc.data().matchStatus,
                tournamentName: doc.data().tournamentName,

                tournamentId: doc.data().tournamentId,
                esportsID: doc.data().esportsID,
                created: moment(doc.data().created.seconds * 1000).format(
                  "DD-MM-YYYY"
                ),

                winners: doc.data().winnersList ? doc.data().winnersList : [],
                winningPercentage: doc.data().winningPercentage,
              });
            });
          })
          .catch((e) => {});
          console.log("tableData",this.tableData);
      } catch (error) {}
    },
  },
  methods: {
    filterdata(DocId) {
      this.$router.push({ name: "tournamentPractice", params: { id: DocId } });
    },
    goToEditEsportsTournament(item) {
      this.$router.push({
        name: "editEsportsTournament",
        params: {
          id: item.id,
          roomId: item.roomId,
          roomPassword: item.roomPassword,
          isRoomId: item.isRoomId,
        },
      });
    },
    editTournament(item) {
      // console.log("items", item);
      let nameRoute = item.isFree
        ? "editFreeEsportsTournament"
        : "editPaidEsportsTournament";

      this.$router.push({
        name: nameRoute,
        params: {
          id: item.id,
        },
      });
    },
    goToEditEsportsPrizeDistribution(item) {
      this.$router.push({
        name: "esportsDistributionVue",
        params: {
          id: item.esportsID,
          winningPercentage: item.winningPercentage,
        },
      });
    },
    async matchCancel(item) {
      let tournamentDocId = item.id;

      try {
        const resp = await axios.post(
          "https://scramble-api.rage.fan/eportsTrigger",
          // "http://localhost:5000/eportsTrigger",
          { tournamentDocId }
        );

        if (resp.data.status) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Match cancelled successfully",
            showConfirmButton: false,
            timer: 2000,
          }).then(window.location.reload());
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: resp.data.Message,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: error,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    getGames() {
      var res = new Date();
      res.setDate(res.getDate() - 2);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date());
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("esportsTournament")
        .where("isContestEnabled", "==", true)
        .where("created", ">=", v2)
        .where("created", "<=", v1)
        .get()
        .then((snapshot) => {
          this.tableData = [];

          snapshot.forEach((doc) => {
            this.tableData.push({
              id: doc.id,
              name: doc.data().gameName,
              esportsID: doc.data().esportsID,
              created: moment(doc.data().created.seconds * 1000).format(
                "DD-MM-YYYY"
              ),
              icon: doc.data().gameImage,
              matchStatus: doc.data().matchStatus,
              tournamentName: doc.data().tournamentName,
              winners: doc.data().winnersList ? doc.data().winnersList : [],
              roomId: doc.data().roomId,
              isRoomId: doc.data().isRoomId,
              roomPassword: doc.data().roomPassword,
              winningPercentage: doc.data().winningPercentage,
              isFree: doc.data().isFree,
            });
          });
        })
        .catch((e) => {});
    },
  },
  created() {
    this.getGames();
  },
};
</script>